import React, { useEffect, useState } from "react";
import styles from "./OTP.module.css";
import Image from "next/image";
import { Clock12 } from "lucide-react";
import { trackEventPreEnrolment } from "@/services/mixpanel";

const ThankYou = ({ isUserExist }: any) => {
  const userStatus = {
    NEW_LEAD: "NEW_LEAD",
    NEW_CANDIDATE: "NEW_CANDIDATE",
    EXISTING_STUDENT: "EXISTING_STUDENT",
  };

  const [isProgramExist, setIsProgramExist] = useState<boolean>(false);

  const userDetails = localStorage.getItem("formData");
  let program_of_interest = "";
  if (userDetails) {
    const userDetailsObject = JSON.parse(userDetails);
    program_of_interest = userDetailsObject?.Programme_Of_Interest;
  }

  useEffect(() => {
    const applications = isUserExist?.data?.application || [];

    const programExists = applications.some(
      (app: any) => app.programName === program_of_interest
    );
    setIsProgramExist(programExists);
  }, [isUserExist, program_of_interest]);

  const handleReserveClick = () => {
    trackEventPreEnrolment("reserve_seat_clicked", {
      program_selected: program_of_interest,
    });
    localStorage.setItem("Eligible_Enter", "true");
    window.open("/eligibility-form", "_blank");
    window.close();
  };

  const handleApplyDashboard = () => {
    window.open("https://apply.regenesys.net/", "_blank");
  };

  const userStatusFromAPI = isUserExist?.data?.status;

  return (
    <div className={styles.otpCompoContainer}>
      <div className={styles.thankyouContainer}>
        <div className={styles.popupContent}>
          <Image
            src="/assets/thanku.png"
            alt="thankyou"
            title="thankyou"
            width={40}
            height={40}
          />
        </div>
        <h3 className={styles.successMessage}>
          Your OTP has been successfully verified.{" "}
        </h3>
        {(userStatusFromAPI === userStatus.NEW_LEAD ||
          (userStatusFromAPI === userStatus.NEW_CANDIDATE && !isProgramExist) ||
          (userStatusFromAPI === userStatus.EXISTING_STUDENT &&
            !isProgramExist)) && (
          <>
            <div className={styles.alertBox}>
              <div className={styles.alertIconContainer}>
                <span className={styles.alertIcon}>
                  <Image
                    src="/assets/alrt.png"
                    alt="alert"
                    title="alert"
                    width={20}
                    height={20}
                  />
                </span>
              </div>
              <div className={styles.alertContent}>
                <p className={styles.alertTitle}>
                  <Clock12 style={{ marginRight: "5px" }} />
                  Seats are filling up fast—only a few left!{" "}
                </p>
                <p className={styles.alertDescription}>
                  {/* eslint-enable react/no-unescaped-entities */}
                  Don’t wait! Now it’s time to secure your seat by just paying
                  Application Fee{" "}
                </p>
              </div>
            </div>
            <button
              className={styles.reserveButton}
              onClick={handleReserveClick}
            >
              Reserve Your Seat
            </button>
          </>
        )}
        {userStatusFromAPI === userStatus.NEW_CANDIDATE && isProgramExist && (
          <>
            <div className={styles.alertBox}>
              <div className={styles.alertIconContainer}>
                <span className={styles.alertIcon}>
                  <Image
                    src="/assets/alrt.png"
                    alt="alert"
                    title="alert"
                    width={20}
                    height={20}
                  />
                </span>
              </div>
              <div className={styles.alertContent}>
                <p className={styles.alertDescription}>
                  {/* eslint-enable react/no-unescaped-entities */}
                  You&#39;ve already applied for this program. Head over to your
                  dashboard to track your application progress.
                </p>
              </div>
            </div>
            <button
              className={styles.reserveButton}
              onClick={handleApplyDashboard}
            >
              Apply Dashboard
            </button>
          </>
        )}

        {userStatusFromAPI === userStatus.EXISTING_STUDENT &&
          isProgramExist && (
            <>
              <div className={styles.alertBox}>
                <div className={styles.alertIconContainer}>
                  <span className={styles.alertIcon}>
                    <Image
                      src="/assets/alrt.png"
                      alt="alert"
                      title="alert"
                      width={20}
                      height={20}
                    />
                  </span>
                </div>
                <div className={styles.alertContent}>
                  <p className={styles.alertDescription}>
                    {/* eslint-enable react/no-unescaped-entities */}
                    You&#39;re already pursuing this qualification. Please reach
                    out to your academic counselor for further guidance.
                  </p>
                </div>
              </div>
            </>
          )}
      </div>
    </div>
  );
};

export default ThankYou;
